import styled from 'styled-components';
import { BaSeTheme } from '@base/react';

const mediaBreakValue = BaSeTheme.breakpoints.tablet.maxWidth;

export const SearchContainer = styled.div`
  display: flex;
  padding: 32px 0;
  justify-content: space-between;
  @media screen and (max-width: ${mediaBreakValue}px) {
    flex-flow: column;
    gap: 8px;
  }
`;

export const SeachInputContainer = styled.div`
  width: 100%;
  max-width: 477px;
  @media screen and (max-width: ${mediaBreakValue}px) {
    max-width: 100vw;
  }
`;

export const SearchSelectInput = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  @media screen and (max-width: ${mediaBreakValue}px) {
    flex-flow: column;
    gap: 0px;
    align-items: flex-start;
    & > div {
      width: 100%;
    }
  }
`;

export const GridContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px 32px;
  padding: 32px 0;
`;

export const ContainerPadding = styled.div`
  @media screen and (max-width: ${BaSeTheme.breakpoints.desktop.maxWidth +
    2}px) {
    padding: 0 24px;
  }
`;

export const NoContentContainer = styled.div`
  max-width: ${BaSeTheme.breakpoints.tablet.minWidth}px;
  margin: 0 auto;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 8px 0;
  img {
    margin: 32px 0;
  }
`;
